module.exports = __webpack_public_path__ + "static/img/头像图片.8783d7d5.png";